import { all, fork } from 'redux-saga/effects';
import { watchAppActions } from './appSaga';
import { watchSubmitQuiz } from './quizSaga';

export default function* rootSaga() {
  yield all([
    fork(watchAppActions),
    fork(watchSubmitQuiz) 
  ]);
}